/**
 * Custom Transloco loader → /i18n/bundles/{locale}.
 *
 * Le backend renvoie ``{translations: {key: text, ...}, rtl, ...}``.
 * Le loader extrait juste ``translations`` pour Transloco qui s'attend à
 * un dict plat.
 *
 * Fallback gracieux : si le backend est indisponible, on tente de servir
 * un bundle FR vide pour ne pas casser l'app (Transloco utilisera la clé
 * comme libellé via le MissingHandler).
 */

import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable, catchError, map, of } from 'rxjs';

import { ConfigService } from '../services/config.service';

@Injectable({ providedIn: 'root' })
export class CodincloudTranslocoLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private cfg = inject(ConfigService);

  getTranslation(lang: string): Observable<Translation> {
    // SAME-ORIGIN en prod : nginx proxifie /i18n/ -> vendor_api. Evite le
    // challenge Cloudflare cross-origin qui vidait les traductions (UI en cles
    // brutes, sidebar "cassee") sur navigateur sans cf_clearance.
    const isProdHost = typeof window !== 'undefined'
      && /(vendeur\.site|vendor\.codincloud\.com)$/i.test(window.location.hostname);
    const base = isProdHost ? '' : this.cfg.apiUrl;
    const url = `${base}/i18n/bundles/${encodeURIComponent(lang)}`;
    return this.http.get<{ translations: Record<string, string> }>(url).pipe(
      map((res) => (res?.translations ?? {}) as Translation),
      catchError(() => of({} as Translation)),
    );
  }
}
